import { Fulfillment } from '@bybeam/platform-types';
import React, { useContext } from 'react';

export const FulfillmentContext = React.createContext<Fulfillment>(undefined);

export default function useFulfillment(): Fulfillment {
  return useContext(FulfillmentContext);
}
